export default {
	attributes: {
		height: 48,
		backgroundCustomSizeUnit: '%',
		tabletBackgroundCustomSizeUnit: '%',
		mobileBackgroundCustomSizeUnit: '%',
		uniqueClass: 'ugb-d08049a',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
	},
}
